import type { FaireProductEntity } from "../../entity_types/product";

export const p_zqa6rkzrns: FaireProductEntity = {
  token: "p_zqa6rkzrns",
  type: "product",
  name: 'Palm & Sabai Grass Round Easter Basket, 13"_Easter Basket',
  brandToken: "b_9f715f8d",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/7d99cdd7d6b6dd7ba2e00ef3787f547748e7a87a5a695db53e5fa8c6a7ea3b8d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4e1d598968cecdaf01a03afe621855bb3e6d2a4489cb872a7f51b154ae4a9d3a.jpeg",
    "https://cdn.faire.com/fastly/32e845ced8fcb51683a6090094446e8e903124cd9aaf43eda1577723d2801e71.jpeg",
    "https://cdn.faire.com/fastly/437ed611983d9d766400659a9d7756d04f8599c4565350bf0b6f9bb0b345ce36.jpeg",
    "https://cdn.faire.com/fastly/855600685edcf2100902d307401a4d8e802f3d3fe5f843bd89367317f1b5d656.jpeg",
    "https://cdn.faire.com/fastly/3ed6b1ea7f7c0fce17c232075b79edd72a5bb2d734a0ab7ad453d6dc2bd7f104.jpeg",
    "https://cdn.faire.com/fastly/01b1d3bc4519d5da34c3ef579005a0de7148b3b5d490e19869eecb60fb1c1809.jpeg",
  ],
  priceDollars: 25,
  description:
    'Light & Durable. Our ethically made sabai grass baskets are perfect for every season. Handwoven by a group of women artisans of India, these baskets are multifunctional and sustainable. Place one on a hall table, sideboard or shelving unit for a simple, decorative touch. Or group a basket with other meaningful mementos such as photo frames, special books or hand crafted objects. \n\nHandmade by skilled women artisans in Odisha, India \n• Ethically made in India \n• Made by skilled women Artisans \n• Made with locally sourced Sabai grass\n• Sustainable material, Small Batch\n• 13"\n\n\nMOQ 2 \n',
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:33.743Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
